// extracted by mini-css-extract-plugin
export default {"ProductTable":"ModifyGiveawayModal_ProductTable__gxwb4"};